import React, { useEffect } from 'react';
import {
  Redirect,
  useHistory,
} from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  OPEN_REPORT_EDIT_PAGE,
  SUCCESS_API_GET_USER_GROUPS,
} from '../actions/actionTypes';
import MainPage from '../components/MainPage';
import getReportDetail from '../actions/api/report/getReportDetail';
import getGroups from '../actions/api/group/getGroups';
import { ReportStatus } from '../components/ReportEdit/TitleArea';
import { PAGE_PATH } from '../lib/constants';
import accessible from '../components/Report/functions/authControl';

const ReportEditContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { reportId: strReportId } = useParams();
  const reportId = Number(strReportId);

  dispatch({ type: OPEN_REPORT_EDIT_PAGE, reportId });

  const apiToken = useSelector(state => state.main.apiToken);
  const isLogin = useSelector(state => state.main.isLogin);
  const targetGroupId = useSelector(state => state.main.targetGroupId);
  const groups = useSelector(state => state.group.groups);
  const reportDetail = useSelector(state => state.report.reportDetail);
  const currentUserInfo = useSelector(state => state.main.userInfo);
  const currentUserRole = useSelector(state => state.main.innerRole);

  useEffect(() => {
    dispatch(getGroups(apiToken, {}, SUCCESS_API_GET_USER_GROUPS));
  }, [apiToken, dispatch, targetGroupId]);

  useEffect(() => {
    if (reportId) {
      dispatch(getReportDetail(apiToken, targetGroupId, reportId));
    }
  }, [apiToken, dispatch, targetGroupId, reportId]);

  useEffect(() => {
    if (!reportDetail.id) {
      return;
    }
    // 操作権限取得
    const controle = accessible(
      currentUserRole,
      currentUserInfo,
      groups,
      reportDetail,
    );
    if (!controle.read) {
      // 閲覧権限が無い場合は一覧を表示する
      history.push(PAGE_PATH.DS_REPORT);
    }
    if (reportDetail.status === ReportStatus.complete) {
      // ステータスを完了に更新後は詳細画面を表示する
      history.push(`${PAGE_PATH.DS_REPORT}/${reportDetail.id}`);
    }
  }, [history, reportDetail, currentUserRole, currentUserInfo, groups]);

  if (!isLogin) {
    return <Redirect to="/login" />;
  }

  return <MainPage />;
};

export default ReportEditContainer;
